import React from "react";
import PropTypes from "prop-types";

const Radio = ({ schema, active, handleChange }) => {
  const handleSubmit = (e) => {
    handleChange(+e.currentTarget.value);
  };

  return (
    <form className="radio__container">
      {schema.map(({ id, label }) => {
        const activeRadio = id === active;
        return (
          <label className="radio__button" key={id}>
            <input
              type="radio"
              value={id}
              checked={activeRadio}
              onChange={handleSubmit}
            />
            {label}
          </label>
        );
      })}
    </form>
  );
};

Radio.propTypes = {
  schema: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
  active: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  handleChange: PropTypes.func.isRequired,
};
export default Radio;
